<template>
  <main :class="`lang-${$store.state.ui.lang}`">
    <div v-if="$route.meta.isRoot">
      <router-view></router-view>
    </div>
    <div class="app" :class="wrapperClass" v-else>
      <transition name="fade-out">
        <p class="loader--App" v-if="loading">{{ $store.getters.getStringTranslation('loading') }}...</p>
      </transition>
      <pop-nav v-if="$route.meta.hasNav !== false"></pop-nav>
      <div :class="{ app__Wrapper: $route.meta.hasNav !== false }">
        <router-view></router-view>
      </div>
      <p class="manualButton">
        <a target="_blank" href="https://world-psi.zendesk.com/hc/en-us"> <icon name="book" /></a>
        <span class="manualButton__Tooltip">Read the manual</span>
      </p>
    </div>
  </main>
</template>

<script>
import PopNav from '@/components/partials/Nav.vue'

export default {
  name: 'app',
  components: {
    PopNav,
  },
  computed: {
    loading() {
      return this.$store.state.ui.loading
    },
    wrapperClass() {
      return this.$store.state.ui.wrapperClass
    },
  },
}
</script>
